import { Router, Test } from 'blop/router'

async def dogPageIndexHandler(_params, _state) {
  console.log('dog page index')
}

def dogPageHandler(params, state) {
  state.dogPage.choice = { breed: params.breed, image: params.image }
}

def todoPageHandler(_params, _state) {
  console.log('todo page')
}

async def astExplorerPageHandler(_params, _state) {
  console.log('ast explorer page')
}

def showcasePageHandler(_params, _state) {
  console.log('showcase page')
}

def playgroundPageHandler(_params, _state) {
  console.log('playground page')
}


def createRouter(state, win=globalThis.window) {
  router = new Router(state, null, win)

  router.add({ path: '/todo', name: 'todo', handler: todoPageHandler })
  router.add({ path: '/dogs/:breed/:image', name: 'doggy', handler: dogPageHandler })
  router.add({ path: '/dogs', name: 'dog', handler: dogPageIndexHandler })
  router.add({ path: '/ast', name: 'ast', handler: astExplorerPageHandler })
  router.add({ path: '/showcase', name: 'showcase', handler: showcasePageHandler })
  router.add({ path: '/playground', name: 'playground', handler: playgroundPageHandler })
  router.add({ path: '/form', name: 'form', handler: (_p1, _p2) => console.log('form page') })
  router.add({ path: '/', name: 'root', handler: (_p1, _p2) => console.log('root page') })

  router.init()
  return router
}
